import { FC } from 'react';
import { getServiceTimeUnitPluralKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { useCommanderSelector } from '@mews-commander/utils';
import { lt } from '@mews/framework';

interface ServiceTimeUnitProps {
    serviceId: string;
}

export const ServiceTimeUnit: FC<ServiceTimeUnitProps> = ({ serviceId }: ServiceTimeUnitProps) => {
    const timeUnitTextKey = useCommanderSelector((state) => getServiceTimeUnitPluralKey(state, { id: serviceId }));

    return timeUnitTextKey ? lt(timeUnitTextKey) : null;
};
